export const handleFrontendError = (
  error,
  fallbackMessage = "Something went wrong"
) => {
  console.error("⚠️ Frontend Error:", error);

  if (error.response) {
    const { status, data } = error.response;
    return data?.message || `Error ${status}: ${fallbackMessage}`;
  }

  if (error.request) {
    return "Unable to connect. Please check your internet connection.";
  }

  return fallbackMessage;
};
